// services/useAutoRefresh.js

export default function useAutoRefresh({
  callback,
  interval = 3 * 60 * 1000,
  refreshOnVisible = true
}) {
  let timer = null
  let loading = false
  let started = false

  async function execute() {
    if (loading) return
    if (document.hidden) {
      reset()
      return
    }

    loading = true

    try {
      await callback()
    } finally {
      loading = false
      reset()
    }
  }

  function reset() {
    clearTimeout(timer)

    if (!started) {
      timer = null
      return
    }

    timer = setTimeout(() => {
      execute()
    }, interval)
  }

  function stop() {
    started = false
    clearTimeout(timer)
    timer = null
    document.removeEventListener(
      'visibilitychange',
      visibilityHandler
    )
  }

  function start() {
    if (started) return

    started = true
    reset()

    if (refreshOnVisible) {
      document.addEventListener(
        'visibilitychange',
        visibilityHandler
      )
    }
  }

  function visibilityHandler() {
    if (!document.hidden) {
      execute()
    }
  }

  return {
    start,
    stop,
    reset,
    refresh: execute
  }
}
